import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/website/assets/img/business/expert-hero.png?v=1")